import Blocks from "@/components/Organisms";

export default function Hero(hero) {
  return <Blocks key={`hero`} sections={[hero.data]}></Blocks>;
}
